

// Add this Wall component
import {useLoader} from "@react-three/fiber";
import {TextureLoader} from "three";
import wallTexture from "../assets/wall.jpeg";
import * as THREE from "three";
import React from "react";

export function Wall({ position, size, rotation = [0, 0, 0] }) {
    // Load the wall texture using the imported path
    const texture = useLoader(TextureLoader, wallTexture);

    // Configure the texture
    texture.wrapS = texture.wrapT = THREE.RepeatWrapping;

    // Increase the repeat values for more pronounced tiling
    // Adjust these values to control the tiling density
    texture.repeat.set(size[0] * 30, size[1] * 0.5);

    return (
        <mesh position={position} rotation={rotation} castShadow receiveShadow>
            <boxGeometry args={size} />
            <meshStandardMaterial map={texture} />
        </mesh>
    );
}